import ClientesLocales from '../Data/Clientes.json';
import { useConsulta } from './sanity';

/**
 * Los PNG de S3 vienen con fondo crema opaco y el logo en gris claro (algunos
 * casi del tono del fondo). Estas versiones están en tinta sobre transparente,
 * una por id de Clientes.json, generadas con:
 *   ffmpeg -i N.png -filter_complex "[0]format=gray,geq=lum='clip((236-lum(X,Y))*11,0,255)'[a];color=c=0x0A0A0A:s=530x150,format=rgb24[c];[c][a]alphamerge" -frames:v 1 -c:v libwebp -lossless 1 N.webp
 * En Sanity el equipo sube PNG o SVG con fondo transparente, de cualquier color:
 * el sitio los pinta a todos igual con un filtro CSS (ver CLASE_LOGO).
 */
const logosTinta = require.context('../assets/home/clientes', false, /\.webp$/);
const LOGOS = Object.fromEntries(logosTinta.keys().map((k) => [k.replace(/\D/g, ''), logosTinta(k)]));

const LOCALES = ClientesLocales.map((c) => ({ id: String(c.id), nombre: c.nombre, logo: LOGOS[c.id] || c.url }));

const LISTA = `*[_type == "cliente" && mostrarEnCarrusel != false && defined(logo.asset)]
    | order(coalesce(orden, 1000) asc, nombre asc) { "id": _id, nombre, logo, sitio }`;

/** Logos a un solo color: tinta sobre crema, crema sobre negro. */
export const CLASE_LOGO = {
    crema: 'brightness-0',
    tinta: 'brightness-0 invert',
};

export function useClientes() {
    const { datos, cargando } = useConsulta(LISTA, null, LOCALES);
    return { clientes: datos || [], cargando };
}
